<template>
  <!-- 重点设备 -->
  <div class="impotant-devices">
    <el-table class="eltabletl" border :data="tableData" style="width: 60%">
      <el-table-column prop="devName" label="设备名称"></el-table-column>
      <el-table-column prop="model" label="设备类型"></el-table-column>
      <el-table-column prop="status" label="设备状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status===0">临期</span>
          <span v-if="scope.row.status===1">正常</span>
          <span v-if="scope.row.status===2">过期</span>
          <span v-if="scope.row.status===3">未及时保养</span>
        </template>

      </el-table-column>
      <el-table-column prop="area" label="区域"></el-table-column>
      <el-table-column prop="linkUser" label="负责人"> </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot="header">
          操作 <i @click="addRow()" style="font-size: 1.2rem;font-weight: 600;cursor:pointer;position: relative;top: 0.1rem;color: #00ffff;" class="el-icon-circle-plus-outline"></i>
        </template>
        <template slot-scope="scope">
          <el-button style="padding:0 10px;" @click="editDev(scope.row);fileList=[]" type="text">修改</el-button>
          <el-button style="padding:0 10px;" @click="del(scope.row) " type="text">删除</el-button>

        </template>
      </el-table-column>
    </el-table>




    <el-dialog v-dialogDrag title="重点设备信息" :close-on-click-modal="false" :visible.sync="xfboxdialog" class="xfdialog">
      <!-- <span slot="label">基本信息</span> -->
      <div class="info">
        <div class="img">
          <h3 class="h-title">设备图片</h3>
          <el-upload 
            action="#" 
            :limit="20" 
            :file-list="fileList" 
            :before-upload="beforeAvatarUpload"
            list-type="picture-card" 
            :http-request="uploadfile" 
            :multiple='false' 
            :auto-upload="true">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
              <span class="el-upload-list__item-actions">
                <!-- <span class="el-upload-list__item-preview" @click="view(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                  <i class="el-icon-download"></i>
                </span> -->
                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <el-dialog v-dialogDrag :visible.sync="dialogVisible">
            <img style=" width: 100%;;height: 24rem" :src="dialogImageUrl" alt="">
          </el-dialog>
        </div>
        <div class="form" style="overflow: auto;height: 25rem;">
          <h3 class="h-title">设备信息</h3>
          <el-form ref="formData" label-width="5rem">
            <el-form-item label="设备名称">
              <el-input v-model="formData.devName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="设备品牌">
              <el-input v-model="formData.devBrand" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="设备型号">
              <el-input v-model="formData.model" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="安装区域">
              <el-input v-model="formData.area" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="负责人">
              <el-input v-model="formData.linkUser" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="生产日期">
              <el-date-picker value-format="yyyy-MM-dd HH:mm:ss"   format="yyyy-MM-dd" style="width: 100%;" 
              v-model="formData.produceDate" type="date" placeholder="选择日期时间"> </el-date-picker>
            </el-form-item>
            <el-form-item label="安装日期">
              <el-date-picker value-format="yyyy-MM-dd HH:mm:ss"   format="yyyy-MM-dd" style="width: 100%;" 
              v-model="formData.installDate" type="date" placeholder="选择日期时间"> </el-date-picker>
            </el-form-item>
            <el-form-item label="售后截止">
              <el-date-picker value-format="yyyy-MM-dd HH:mm:ss"   format="yyyy-MM-dd" style="width: 100%;" 
              v-model="formData.byDate" type="date" placeholder="选择日期时间"> </el-date-picker>
            </el-form-item>
            <el-form-item label="生产厂商">
              <el-input v-model="formData.customName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="使用状态">
              <el-select v-model="formData.runStatus" placeholder="请选择">
                <el-option label="关机" :value="0"></el-option>
                <el-option label="正常" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运行状态">
              <el-select v-model="formData.useStatus" placeholder="请选择">
                <el-option label="未正常使用" :value="0"></el-option>
                <el-option label="正常使用" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保养周期">
              <el-input type="number" v-model="formData.maintain" placeholder="请输入">
                <template slot="suffix">日/次</template>
              </el-input>
            </el-form-item>
            <el-form-item label="维保单位">
              <el-input v-model="formData.maintainCompany" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="当前状态">
              <el-select v-model="formData.status" placeholder="请选择">
                <el-option label="临期" :value="0"></el-option>
                <el-option label="正常" :value="1"></el-option>
                <el-option label="过期 " :value="2"></el-option>
                <el-option label="未及时保养 " :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <h3 style="border-left: #3570ff solid 0.5em;line-height: 1.8em;padding-left:.6rem;margin: 1em 0;font-size: 1.5em;">设备能耗曲线对比</h3>
      <table class="mytable">
        <thead>
          <tr>
            <th style="width:12%;">月份</th>
            <th v-for="(mon,index) in 12" :key="index">{{index+1}}月</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="background:#203bd5;text-align:center">去年(折标煤吨)</td>
            <td v-for="(item,index) in formLineData.lastYear" :key="index">
              <el-input type="number" v-model="item.lossPower" placeholder="请输入"></el-input>
            </td>
          </tr>
          <tr>
            <td style="background:#203bd5;text-align:center">今年(折标煤吨)</td>
            <td v-for="(item,index) in formLineData.nowYear" :key="index">
              <el-input type="number" v-model="item.lossPower" placeholder="请输入"></el-input>
            </td>
          </tr>
        </tbody>
      </table>
 

      <span slot="footer" class="dialog-footer">
        <el-button @click="saveAllData" type="primary">保存</el-button>
        <el-button @click="xfboxdialog = false">关闭</el-button>
      </span>

    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="dialogVisible">
      <img style=" width: 100%;;height: 24rem" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import upapi from '@/apis/upload'
import api from '@/apis/power/power'
export default {
  data() {
    return {
      disabled: false,//图片上传框禁用
      xfboxdialog: false,//新增修改弹框
      dialogVisible: false,//查看图片弹框
      dialogImageUrl: '',//查看图片临时路径
      fileList: [],//上传图片数据
      tableData: [],//列表表格数据

      //重点设备基础数据
      formData:{
        id:'',//id
        area: '', //区域
        byDate: '', //截至售后日期
        customName: '', //厂家
        devBrand: '', //品牌
        devName: '', //设备名称
        installDate: '', //安装日期
        linkUser: '', //负责人
        maintain: '', //保养周期
        maintainCompany: '', //维保单位
        model:'',//设备型号
        pictures: '', //图片
        produceDate: '', //生产日期
        runStatus: 1, //运行状态 0关机 1正常
        status: 1, //当前状态 0临期 1正常 2过期 3 未即时保养
        useStatus: 1, //使用状态 0未正常使用 1 正常使用
        type:3,
      },
      //重点设备基折线图数据
      formLineData:'',
      lineID:'',//折线图数据临时id
    }
  },
  mounted() {
    this.getDevList()
  },
  methods: {
    //获取列表
    getDevList(){
      api.getImpDevList2().then((res) => {
        if (res.code === 10000) {
          this.tableData = res.data
        } else {
          this.$message.error(res.message)
          return;
        }
      })
    },
    //添加数据
    addRow() {
      this.fileList = []
      this.formData =  {
        area: '', //区域
        byDate: '', //截至售后日期
        customName: '', //厂家
        devBrand: '', //品牌
        devName: '', //设备名称
        installDate: '', //安装日期
        linkUser: '', //负责人
        maintain: '', //保养周期
        maintainCompany: '', //维保单位
        model:'',//设备型号
        pictures: '', //图片
        produceDate: '', //生产日期
        runStatus: 1, //运行状态 0关机 1正常
        status: 1, //当前状态 0临期 1正常 2过期 3 未即时保养
        useStatus: 1, //使用状态 0未正常使用 1 正常使用
        type:3,
      }
      this.formLineData = {
        lastYear:[
          {lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},
          {lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},
          {lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''}
        ],
        nowYear:[
          {lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},
          {lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''},
          {lossPower:''},{lossPower:''},{lossPower:''},{lossPower:''}
        ],
      },
      this.xfboxdialog= true
    },
    //编辑设备
    editDev(row) {
      api.getImpDevDetail(row.id).then((res) => {
        if (res.code === 10000) {
          this.formData =  res.data.safeFighting
          this.formLineData = JSON.parse(res.data.devEnergy.jsonData)
          this.lineID = res.data.devEnergy.id
          if (this.formData.pictures) {
            this.fileList = JSON.parse(this.formData.pictures)
          }else{
            this.fileList = []
          }
          this.xfboxdialog= true
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //删除设备
    del(row) {
      this.$confirm('确认删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        api.delImpDev(row.id).then((res) => {
          if (res.code == 10000) {
            this.$message.success('删除成功')
            this.getDevList()
          } else {
            this.$message.error(res.message)
            return;
          }
        })
      })
    },
    // //查看图片
    // view(file) {
    //   this.dialogImageUrl = file.url
    //   this.dialogVisible = true
    // },
    // //下载图片
    // handleDownload(file) {
    //   open(file.url)
    // },

    //上传图片
    uploadfile(val) {
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.fileList.push({
            name: val.file.name,
            url: res.data,
            uid: val.file.uid,
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //删除图片
    handleRemove(file) {
      return this.$confirm(`确定移除此图片？`).then(() => {
        this.fileList.map((item, index) => {
          if (item.uid == file.uid) {
            this.fileList.splice(index, 1)
            upapi.del({ params: { filePath: file.url } }).then()
          }
        })
      })
    },
    //保存新增数据
    saveAllData() {
      this.formData.pictures=JSON.stringify(this.fileList)
      let obj = {
        devEnergy:{
          jsonData:JSON.stringify(this.formLineData)
        },
        safeFighting:this.formData
      }
      if (this.formData.id) {
        obj.devEnergy['id'] = this.lineID
        api.upDateImpDev(obj).then((res) => {
          if (res.code === 10000) {
            this.$message.success('修改成功')
            this.getDevList()
            this.xfboxdialog = false
          } else {
            this.$message.error(res.message)
            return;
          }
        })
      } else {
        api.saveImpDev(obj).then((res) => {
          if (res.code === 10000) {
            this.$message.success('保存成功')
            this.getDevList()
            this.xfboxdialog = false
          } else {
            this.$message.error(res.message)
            return;
          }
        })
      }
    },
    //判断上传文件格式是否合法
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'||file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
  },
}
</script>

<style scoped  lang="less">
.impotant-devices {
  padding-top: 10px;
  .el-form-item {
    margin-bottom: 15px;
  }
  /deep/ .el-form-item__label {
    background: #3570ff;
  }
  .xfdialog {
    .el-select {
      width: 100%;
    }

    .el-upload-list li {
      width: 16rem !important;
      height: 11rem !important;
      margin: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    /deep/ .el-upload-list li {
      width: 10rem !important;
      height: 10rem !important;
      margin: 10px;
    }


    /deep/ .el-upload-list__item {
      border-radius: 0;
    }
    /deep/ .el-upload--picture-card i {
      font-size: 2rem !important;
    }
    /deep/  .el-upload-list__item-actions span{
      font-size: 2rem;
    }    
    /deep/ .el-upload--picture-card {



      background-color: transparent;
      width: 10rem !important;
      margin: 10px;
      height: 10rem !important;
      line-height: 9rem !important;
      text-align: center;
      border: #555e86 dashed 1px;
      font-size: 2rem;
      border-radius: 0;
    }

    // /deep/ .el-dialog__body {
    //   min-height: 65em;
    // }

    .info {
      display: flex;
      .h-title {
        border-left: #3570ff solid 0.5em;
        line-height: 1.8em; padding-left: .6rem;
        margin: 1em 0; 
        font-size: 1.5em;
      }
      .img {
        width: 49%;
        margin-right: 1rem;
        flex-shrink: 0;
      }
      .form {
        flex: 1;
        height: 60em;
        width: 100%;
        overflow-y: auto;
        overflow: hidden;
      }
      .item {
        border-bottom: #555e86 dashed 1px;
        padding: 0.4rem 0.5rem;
        display: flex;
        flex-direction: row;
        label {
          width: 5rem;
          flex-shrink: 0;
          text-align: right;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 10px;
        }
        span {
          color: #fff;
        }
      }
      .item:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>